import { useState } from 'react';
import { Stack, Select, Text, Box, Divider } from '@mantine/core';
import CompanyAppendicesSandbox from './company-appendices-sandbox/CompanyAppendicesSandbox';
import ConnectedAssetsSandbox from './connected-assets-sandbox/ConnectedAssetsSandbox';
import MatchingSandbox from './connected-assets-sandbox/matching-sandbox/MatchingSandbox';
import EmailSandbox from './email-sandbox/EmailSandbox';
import MeetingNoteStructureSandbox from './meeting-note-structure-sandbox/MeetingNoteStructureSandbox';
import TipSandbox from './tip-sandbox/TipSandbox';

const SANDBOX_COMPONENTS = [
  { value: 'company-appendices', label: 'Company appendices' },
  { value: 'connected-assets', label: 'Connected products' },
  { value: 'matching', label: 'Matching workspace' },
  { value: 'email', label: 'Email' },
  { value: 'tip', label: 'Tip' },
  { value: 'meeting-note-structure', label: 'Meeting note structure selection' },
] as const;

type SandboxComponentValue = (typeof SANDBOX_COMPONENTS)[number]['value'];

export default function SandboxTab() {
  const [selected, setSelected] = useState<SandboxComponentValue | null>(null);

  const renderComponent = () => {
    switch (selected) {
      case 'company-appendices':
        return <CompanyAppendicesSandbox />;
      case 'connected-assets':
        return <ConnectedAssetsSandbox />;
      case 'matching':
        return <MatchingSandbox />;
      case 'email':
        return <EmailSandbox />;
      case 'tip':
        return <TipSandbox />;
      case 'meeting-note-structure':
        return <MeetingNoteStructureSandbox />;
      default:
        return (
          <Text c="dimmed" ta="center" mt="xl">
            Select a component to view its sandbox demo
          </Text>
        );
    }
  };

  return (
    <Stack p="md">
      <Text size="xl" fw={700}>
        Component Sandbox
      </Text>
      <Text c="dimmed">Test and demo various components</Text>

      <Select
        label="Select component"
        placeholder="Choose a component..."
        data={SANDBOX_COMPONENTS}
        value={selected}
        onChange={value => setSelected(value as SandboxComponentValue)}
        clearable
        w={300}
      />

      <Divider />

      <Box>{renderComponent()}</Box>
    </Stack>
  );
}
